import { useQuery } from "@tanstack/react-query";
import { DesignTemplateServices } from "@/services/bedrock/DesignTemplateServices";
import { designKeys } from "@/services/bedrock/queryKeys";

/**
 * A slide version's stored template code, for the admin Source sheet. Never considered fresh, so
 * reopening the sheet always shows what is stored; never refetched behind the admin's back while
 * they edit.
 */
export function useTemplateSource(templateId: number | null, { enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: designKeys.templateSource(templateId ?? 0),
    queryFn: () => DesignTemplateServices.source(templateId as number),
    enabled: enabled && templateId != null,
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
}
